import {createTheme} from "@mantine/core";
import "@fontsource-variable/edu-qld-hand/index.css";

export const theme = createTheme({
  defaultRadius: "sm",
  primaryColor: "teal",
  colors: {
    // Custom dark palette with a subtle greenish/teal tint
    dark: [
      "#C1C2C5",
      "#A6A7AB",
      "#909296",
      "#5C5F66",
      "#373A40",
      "#2C2E33",
      "#25262B",
      "#12231e", // Background dark (greenish)
      "#0d1a16", // Background darker (greenish)
      "#08100d", // Background darkest (greenish)
    ],
  },
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
  headings: {
    fontFamily:
      "Edu QLD Hand Variable, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
    fontWeight: "700",
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "2rem",
    xl: "3rem",
  },
  radius: {
    xs: "0.2rem",
    sm: "0.4rem",
    md: "0.8rem",
    lg: "1.2rem",
    xl: "1.6rem",
  },
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.1)",
    sm: "0 2px 8px rgba(0, 0, 0, 0.1)",
    md: "0 4px 16px rgba(0, 0, 0, 0.2)",
    lg: "0 8px 32px rgba(0, 0, 0, 0.3)",
    xl: "0 12px 48px rgba(0, 0, 0, 0.4)",
  },
});
